// extracted by mini-css-extract-plugin
module.exports = {"Facet":"Facets_Facet__qVazu"};